// @ts-nocheck
import {
    chain,
    SetProductInfo,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateVariantSelection";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { shouldProductLoadRealTime } from "@store/Framework/Common/Utilities/productUtilities";

/**
 * Initialize state configuration on variant selection completed
 */
addToChainAfter(chain, SetProductInfo, props => {
    const { productInfo, selectedProductId: productId } = props;
    const product = getProductState(props.getState(), productId).value;

    if (!productInfo || !productId || !props.variantSelectionCompleted || !product) {
        return;
    }

    props.dispatch({
        type: "Pages/ProductDetails/InitConfigurationSelection",
        configuration: product.detail?.configuration || null,
    });

    props.dispatch({
        type: "Pages/ProductDetails/ResetConfigurationEmbroideries",
    });

    if (shouldProductLoadRealTime(product)) {
        props.dispatch(
            loadRealTimePricing({
                productPriceParameters: [productInfo],
                onSuccess: realTimePricing => {
                    const pricing = realTimePricing.realTimePricingResults!.find(
                        o => o.productId === productInfo.productId,
                    );
                    if (pricing) {
                        props.dispatch({
                            type: "Pages/ProductDetails/CompleteLoadRealTimePricing",
                            pricing,
                        });
                    } else {
                        props.dispatch({
                            type: "Pages/ProductDetails/FailedLoadRealTimePricing",
                            productId,
                        });
                    }
                },
                onError: () => {
                    props.dispatch({
                        type: "Pages/ProductDetails/FailedLoadRealTimePricing",
                        productId,
                    });
                },
                onComplete(realTimePricingProps) {
                    if (realTimePricingProps.apiResult) {
                        this.onSuccess?.(realTimePricingProps.apiResult);
                    } else if (realTimePricingProps.error) {
                        this.onError?.(realTimePricingProps.error);
                    }
                },
            }),
        );

        props.dispatch(
            loadRealTimeInventory({
                productIds: [productId],
                onComplete: realTimeInventoryProps => {
                    const realTimeInventory = realTimeInventoryProps?.apiResult;
                    if (realTimeInventory) {
                        props.dispatch({
                            type: "Pages/ProductDetails/CompleteLoadRealTimeInventory",
                            realTimeInventory,
                        });
                    }
                },
            }),
        );
    }
});
